module.exports = __webpack_public_path__ + "static/kakaobank_img02@2x-a8185bb27a20a95fcf926ea9b1cf71be.jpg";